import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (process.env.NODE_ENV === 'production' && !window.Cypress) {
  Raven.config('https://cf8a1fef41d7437ab5fcc9046f7b2ff6@sentry.4teamwork.ch/70')
    .addPlugin(RavenVue, Vue)
    .install();
}
